export type ParsedPropertyName = {
    propName: string;
    paramName?: string;
};

export const parsePropertyName = (propNameFull: string): ParsedPropertyName => {
    const [propName, paramName] = propNameFull.split('-', 2);
    return { propName, paramName };
};
